import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import { useState } from 'react';
import SearchBar from 'src/componentes/filtro/search-drawer/SearchBar';
import BasicsSection from './SearchDrawer/BasicsSection';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';

const ModeloAvaliacaoSearch = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <>
      <SearchBar
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <BasicsSection
        model={model}
        resources={resources}
        intl={intl}
        searchQuery={searchQuery}
      />
      <CustomFieldsSection
        model={model}
        intl={intl}
        searchQuery={searchQuery}
      />
    </>
  );
};

export default ModeloAvaliacaoSearch;
